import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { cssMainSelector } from "../lib/cssSelectors";
import styled from "styled-components";
import { withTranslation } from "react-i18next";
import { CSS_CLASS_PREFIX } from "../constants/css";

const MemoriesWrapper = styled.div`
  ${p => cssMainSelector(p.theme.tdsId)} {
  }
`;

const Memory = styled.div`
  ${p => cssMainSelector(p.theme.tdsId)} {
    background-color: ${p => p.theme.color.white};
    border-radius: ${p => p.theme.generic.borderRadius};
    box-shadow: 0 1px 3px 0 ${p => p.theme.color.darkLavender};
    cursor: pointer;
    display: inline-block;
    height: 34px;
    user-select: none;
    width: 70px;

    &.${CSS_CLASS_PREFIX}-first-and-last-phone-memory {
      border-radius: 100px 100px 100px 100px;
    }

    &.${CSS_CLASS_PREFIX}-first-phone-memory {
      border-radius: 100px 0 0 100px;
    }

    &.${CSS_CLASS_PREFIX}-last-phone-memory {
      border-radius: 0 100px 100px 0;
    }

    &.${CSS_CLASS_PREFIX}-selected-phone-memory,
      &.${CSS_CLASS_PREFIX}-selected-phone-memory:hover {
      background-color: ${p => p.theme.color.lavender};
      box-shadow: inset 0 1px 2px 0 ${p => p.theme.color.silver};
      cursor: auto;
    }

    &:hover {
      background-color: ${p => p.theme.color.aliceBlue};
    }
  }
`;

const MemoryText = styled.div`
  ${p => cssMainSelector(p.theme.tdsId)} {
    border-radius: ${p => p.theme.generic.borderRadius};
    color: ${p => p.theme.color.cornFlowerBlue};
    font-weight: ${p => p.theme.font.weightBold};
    line-height: 34px;
    text-align: center;
    vertical-align: middle;
  }
`;

class PhoneMemorySelector extends PureComponent {
  render() {
    try {
      return <MemoriesWrapper>{this.phoneMemoryBlocks()}</MemoriesWrapper>;
    } catch (e) {
      return null;
    }
  }

  phoneMemoryBlocks() {
    const { phone, phones, t, updateFilterPhoneId } = this.props;
    const items = [];
    let i = 1;
    let totalCount = phones.length;

    phones.sort((a, b) => a.memory - b.memory);

    for (const memoryPhone of phones) {
      let firstLastClass = "";
      let selectedClass = "";

      if (phone.id === memoryPhone.id) {
        selectedClass = `${CSS_CLASS_PREFIX}-selected-phone-memory`;
      }

      if (i === 1 && i === totalCount) {
        firstLastClass = `${CSS_CLASS_PREFIX}-first-and-last-phone-memory`;
      } else if (i === 1) {
        firstLastClass = `${CSS_CLASS_PREFIX}-first-phone-memory`;
      } else if (i === totalCount) {
        firstLastClass = `${CSS_CLASS_PREFIX}-last-phone-memory`;
      }

      const extraClasses = `${selectedClass} ${firstLastClass}`;

      if (phone.id === memoryPhone.id) {
        items.push(
          <Memory key={i} className={`${extraClasses}`}>
            <MemoryText>
              {memoryPhone.memory} {t("gb")}
            </MemoryText>
          </Memory>
        );
      } else {
        items.push(
          <Memory
            key={i}
            className={`${extraClasses}`}
            onClick={updateFilterPhoneId.bind(this, memoryPhone.id)}
          >
            <MemoryText>
              {memoryPhone.memory} {t("gb")}
            </MemoryText>
          </Memory>
        );
      }

      i += 1;
    }

    return items;
  }
}

PhoneMemorySelector.propTypes = {
  phone: PropTypes.object.isRequired,
  phones: PropTypes.array.isRequired,
  updateFilterPhoneId: PropTypes.func.isRequired
};

export default withTranslation(["phoneMemory"])(PhoneMemorySelector);
